<sync-dialog
    [open]="open"
    [onClose]="close"
    [config]="{
        title: 'Purchase more users',
        isClosable: true,
        actionButton: 'Purchase',
        cancelButton: 'Cancel',
        onCancelClick: close,
        onActionClick: onActionClick,
    }"
>
    <div class="body">
        <ng-container *ngIf="isLoading">
            <sync-spinner />
        </ng-container>
        <ng-container *ngIf="!isLoading">
            <p class="desc">Select the number of additional users to purchase.</p>
            <sync-select
                [label]="'Additional users'"
                [value]="selectedValue"
                [onSelectionChange]="onSelectionChange"
                [list]="options"
                [leadAdornments]="true"
                leadAdornmentsType="icon"
                leadIconAdornment="user"
            />
        </ng-container> 
    </div>
</sync-dialog>
